export default "__VITE_ASSET__C_nmZTx1__"